module.exports = __webpack_public_path__ + "static/2-97c276f358255502ddd0fd821e074b8d.png";